var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getValueByOperatorAndFieldType } from './field';
import { FieldBizType, SQLOperator } from '../_constants/field';
/** 根据条件拼接 where sql */
var spliceWhereSQLFragmentByConditions = function (fnParams) {
    var conditions = fnParams.conditions, entities = fnParams.entities, params = fnParams.params, whereJoiner = fnParams.whereJoiner, entityMap = fnParams.entityMap, curEntity = fnParams.curEntity, entityFieldMap = fnParams.entityFieldMap;
    var curConditions = conditions
        .filter(function (condition) { return condition.fieldId; })
        /** 筛选条件对应值不存在的情况 */
        .filter(function (condition) {
        var _a, _b;
        if (condition.conditions) {
            return true;
        }
        else {
            /** 变量 */
            if (((_a = condition.value) === null || _a === void 0 ? void 0 : _a.startsWith('{')) && ((_b = condition.value) === null || _b === void 0 ? void 0 : _b.endsWith('}'))) {
                var curValue = condition.value.substr(1, condition.value.length - 2);
                /** 非实体字段，即使用的变量，如 params.id */
                if (!new RegExp("^".concat(entities.map(function (e) { return e.name; }).join('|'), "\\.")).test(curValue)) {
                    var valueKeys = curValue.split('.').slice(1);
                    var preValue = params;
                    var value = undefined;
                    for (var idx = 0; idx < valueKeys.length; idx++) {
                        var key = valueKeys[idx];
                        preValue = preValue[key];
                        if (idx === valueKeys.length - 1) {
                            value = preValue;
                        }
                        else if (typeof preValue !== 'object' || preValue === null) {
                            break;
                        }
                    }
                    if (condition.operator === 'IN' || condition.operator === 'NOT IN') {
                        if (Array.isArray(value) && !(value === null || value === void 0 ? void 0 : value.length)) {
                            return false;
                        }
                        else {
                            return value !== undefined && value !== '';
                        }
                    }
                    return value !== undefined;
                }
            }
            else {
                return [SQLOperator.IS_NOT_NULL, SQLOperator.IS_NULL].includes(condition === null || condition === void 0 ? void 0 : condition.operator) ? true : (condition === null || condition === void 0 ? void 0 : condition.value) !== undefined;
            }
        }
        return true;
    });
    var conditionSqlList = [];
    curConditions.forEach(function (condition) {
        var _a, _b, _c, _d;
        var curSQL;
        if (condition.conditions) {
            curSQL = spliceWhereSQLFragmentByConditions({
                conditions: condition.conditions,
                entities: entities,
                whereJoiner: condition.whereJoiner,
                params: params,
                entityMap: entityMap,
                curEntity: curEntity,
                entityFieldMap: entityFieldMap,
            });
        }
        else {
            var field = entityFieldMap[condition.entityId + condition.fieldId];
            /** 变量名拼接 */
            var fieldName = field.name;
            if (condition.fromPath.length) {
                var lastPath = condition.fromPath[condition.fromPath.length - 1];
                var parentField = entityFieldMap[lastPath.entityId + lastPath.fieldId];
                var isCountCondition = ((_b = (_a = parentField.mapping) === null || _a === void 0 ? void 0 : _a.condition) === null || _b === void 0 ? void 0 : _b.startsWith('count(')) && ((_d = (_c = parentField.mapping) === null || _c === void 0 ? void 0 : _c.condition) === null || _d === void 0 ? void 0 : _d.endsWith(')'));
                fieldName = "MAPPING_".concat(__spreadArray(__spreadArray([], condition.fromPath.map(function (p) { return entityFieldMap[p.entityId + p.fieldId].name; }), true), [isCountCondition ? '总数' : field.name], false).join('_'));
            }
            var value = condition.value || '';
            var isEntityField = false;
            /** 支持直接使用数据库字段，如 文件表.id = 用户表.文件id */
            if (condition.value.startsWith('{') && condition.value.endsWith('}')) {
                var curValue = condition.value.substr(1, condition.value.length - 2);
                if (new RegExp("^".concat(entities.map(function (e) { return e.name; }).join('|'), "\\.")).test(curValue)) {
                    value = curValue;
                    isEntityField = true;
                }
                else {
                    var valueKeys = curValue.split('.').slice(1);
                    var preValue = params;
                    for (var idx = 0; idx < valueKeys.length; idx++) {
                        var key = valueKeys[idx];
                        preValue = preValue[key];
                        if (idx === valueKeys.length - 1) {
                            value = preValue;
                        }
                        else if (typeof preValue !== 'object' || preValue === null) {
                            // @ts-ignore
                            value = undefined;
                            break;
                        }
                    }
                }
            }
            curSQL = "".concat(fieldName, " ").concat(condition.operator, " ").concat(isEntityField ? value : getValueByOperatorAndFieldType(field.dbType, condition.operator, value));
        }
        curSQL && conditionSqlList.push(curSQL);
    });
    /** 只有多个条件才需要括号拼接 */
    var sql = "".concat(conditionSqlList.length > 1 ? '(' : '').concat(conditionSqlList.join(" ".concat(whereJoiner, " "))).concat(conditionSqlList.length > 1 ? ')' : '');
    var prefix = '';
    /** whereJoiner 不存在表示最外层 SQL */
    // if (!whereJoiner) {
    // 	/** 当 condition 存在时 */
    // 	prefix = `WHERE _STATUS_DELETED = 0${sql ? ' AND ' : ''}`;
    // }
    if (!whereJoiner && sql) {
        prefix = 'WHERE ';
    }
    return prefix + sql;
};
export var spliceSelectSQLByConditions = function (fnParams) {
    var conditions = fnParams.conditions, entities = fnParams.entities, params = fnParams.params, limit = fnParams.limit, _a = fnParams.orders, orders = _a === void 0 ? [] : _a, pageNum = fnParams.pageNum, fields = fnParams.fields, showPager = fnParams.showPager, selectCount = fnParams.selectCount, isEdit = fnParams.isEdit;
    var curEntity = entities.find(function (e) { return e.selected; });
    if (curEntity && curEntity.fieldAry.length) {
        /** 实体 Map */
        var entityMap_1 = {};
        /** 实体 + 字段的 Map */
        var entityFieldMap_1 = {};
        entities.forEach(function (entity) {
            entityMap_1[entity.id] = entity;
            entity.fieldAry.forEach(function (field) {
                var _a, _b, _c;
                entityFieldMap_1[entity.id + field.id] = field;
                if (entity.isSystem && !field.isPrivate) {
                    entityFieldMap_1[entity.id + field.name] = field;
                }
                if ((_c = (_b = (_a = field.mapping) === null || _a === void 0 ? void 0 : _a.entity) === null || _b === void 0 ? void 0 : _b.fieldAry) === null || _c === void 0 ? void 0 : _c.length) {
                    field.mapping.entity.fieldAry
                        .filter(function (f) { return f.bizType === FieldBizType.CALC; })
                        .forEach(function (f) { return entityFieldMap_1[field.mapping.entity.id + f.id] = f; });
                }
            });
        });
        /** 数据查询语句 */
        var sql = [];
        /** 查询总数语句 */
        var countSql = [];
        var fieldList_1 = [];
        // const getTableName = table => isEdit ? table : `${table}__VIEW`;
        // const entityNames: string[] = [getTableName(curEntity.name)];
        var getTableName_1 = function (table) { return table; };
        var entityNames = [getTableName_1(curEntity.id)];
        var conditionFields_1 = [];
        var formatCondition_1 = function (condition) {
            condition.forEach(function (con) {
                if (con.conditions) {
                    formatCondition_1(con.conditions);
                }
                else if (con.fieldId) {
                    conditionFields_1.push(con);
                    conditionFields_1.push.apply(conditionFields_1, con.fromPath.slice(1).map(function (path, index) {
                        return __assign(__assign({}, path), { fromPath: con.fromPath.slice(0, index + 1) });
                    }));
                }
            });
        };
        formatCondition_1([conditions]);
        /** 排序可按照 fieldId 或 fieldName */
        orders = orders
            .map(function (order) {
            var _a, _b;
            if (order.fieldId) {
                return __assign(__assign({}, order), { fromPath: order.fromPath || [] });
            }
            else if (order.fieldName) {
                /** 前端传入的排序，根据排序字段名称（如： 物料.物料ID）匹配出 Order 类型数据 */
                var names = String(order.fieldName).split('.');
                var fieldPath = [];
                var nowEntity = curEntity;
                var _loop_1 = function () {
                    if (!nowEntity) {
                        return { value: void 0 };
                    }
                    var curName = names.shift();
                    var curField = nowEntity.fieldAry.find(function (field) { return field.name === curName; });
                    if (!curField) {
                        return { value: void 0 };
                    }
                    fieldPath.push({ fieldId: curField.id, entityId: nowEntity.id, fieldName: curField.name, fromPath: [] });
                    nowEntity = entityMap_1[(_b = (_a = curField.mapping) === null || _a === void 0 ? void 0 : _a.entity) === null || _b === void 0 ? void 0 : _b.id];
                };
                while (names.length) {
                    var state_1 = _loop_1();
                    if (typeof state_1 === "object")
                        return state_1.value;
                }
                if (fieldPath.length) {
                    return __assign(__assign({}, fieldPath.pop()), { order: order.order, fromPath: fieldPath });
                }
            }
        })
            .filter(Boolean)
            /** @ts-ignore */
            .reduce(function (pre, order) {
            return __spreadArray(__spreadArray(__spreadArray([], pre, true), [
                order
            ], false), order.fromPath.slice(1).map(function (path, index) {
                return __assign(__assign({}, path), { fromPath: order.fromPath.slice(0, index + 1) });
            }), true);
        }, []);
        /** 所有使用到的字段，类型定义为 SelectedField */
        var allFields_1 = __spreadArray(__spreadArray(__spreadArray([], fields, true), orders, true), conditionFields_1, true).reduce(function (pre, field) {
            var entityField = entityFieldMap_1[field.entityId + field.fieldId];
            /** 计算字段的前置路径，依赖于当前映射字段的 path */
            var fromPathPrefix = field.fromPath.slice(0, -1);
            if (entityField.bizType === FieldBizType.CALC) {
                if (!entityField.hasHandle && fromPathPrefix.length) {
                    entityField.hasHandle = true;
                    /** 处理字段前缀，依赖于当前映射字段的 path */
                    entityField.sql = entityField.sql
                        .replace(/MAPPING_/g, "MAPPING_".concat(fromPathPrefix.map(function (f) { return entityFieldMap_1[f.entityId + f.fieldId].name; }), "_"));
                }
                return __spreadArray(__spreadArray(__spreadArray([], pre, true), [
                    field
                ], false), (entityField.fields || []).map(function (f) {
                    return __assign(__assign({}, f), { fromCalcField: field, fromPath: __spreadArray(__spreadArray([], fromPathPrefix, true), f.fromPath, true) });
                }), true);
            }
            else {
                return __spreadArray(__spreadArray([], pre, true), [field], false);
            }
        }, []);
        /** 所有使用到的字段的 Map */
        var allFieldsMap_1 = {};
        allFields_1.forEach(function (field) {
            var paths = __spreadArray(__spreadArray([], (field.fromPath || []).map(function (p) { return p.fieldId; }), true), [field.fieldId], false).join('.');
            if (!allFieldsMap_1[paths]) {
                allFieldsMap_1[paths] = field;
            }
            else {
                if (allFieldsMap_1[paths].fromCalcField && !field.fromCalcField) {
                    allFieldsMap_1[paths].fromCalcField = undefined;
                }
            }
        });
        allFields_1 = Object.values(allFieldsMap_1);
        /** 当前实体中被使用到的字段 ID */
        var curFieldIds_1 = allFields_1
            .map(function (field) {
            var _a, _b, _c;
            if (field.entityId === curEntity.id && !((_a = field.fromPath) === null || _a === void 0 ? void 0 : _a.length)) {
                return field.fieldId;
            }
            else if (((_b = field.fromPath[0]) === null || _b === void 0 ? void 0 : _b.entityId) === curEntity.id) {
                return (_c = field.fromPath[0]) === null || _c === void 0 ? void 0 : _c.fieldId;
            }
        })
            .filter(Boolean);
        /** 拼接 LEFT JOIN 语句 */
        var spliceLeftJoinSql_1 = function (mappingFields, depIndex, fromPath, parentEntity) {
            var entityNames = [];
            mappingFields.forEach(function (parentField) {
                var _a, _b;
                if (!parentField) {
                    return;
                }
                /** 嵌套层级相匹配，且以当前 mapping 字段作为父字段的所有使用到的字段 */
                var depFields = allFields_1.filter(function (f) { return f.fromPath.length === depIndex && f.fromPath[f.fromPath.length - 1].fieldId === parentField.id; });
                /** 不存在嵌套字段时，无需 join 表 */
                if (!depFields.length) {
                    return;
                }
                var entity = parentField.mapping.entity;
                /** 连表的条件 */
                var condition = String(parentField.mapping.condition);
                /** 连表类型， primary - 主动关联，foreigner 被关联 */
                var type = parentField.mapping.type;
                /** 源实体，即实体面板中存在的实体 */
                var originEntity = entityMap_1[entity.id];
                /** 与主实体存在关联关系的外键字段 */
                var relationField = null;
                if (type === 'primary') {
                    relationField = (_a = originEntity.fieldAry.find(function (f) { return f.isPrimaryKey; })) !== null && _a !== void 0 ? _a : null;
                }
                else if (type === 'foreigner') {
                    relationField = (_b = originEntity.fieldAry.find(function (f) { return f.bizType === 'relation' && f.relationEntityId === parentEntity.id; })) !== null && _b !== void 0 ? _b : null;
                }
                if (!relationField) {
                    return;
                }
                var leftJoinSqlList = spliceLeftJoinSql_1(depFields.map(function (f) { return entityFieldMap_1[f.entityId + f.fieldId]; }), depIndex + 1, __spreadArray(__spreadArray([], fromPath, true), [parentField], false), originEntity);
                var isMaxCondition = condition.startsWith('max(') && condition.endsWith(')');
                var SEPARATOR = '$$';
                var entityName = '';
                /** 关联，当前实体主动关联另一个实体，即当前实体字段存在一个字段作为外键关联另一个实体的主键（id） */
                if (type === 'primary') {
                    var relationField_1 = parentEntity.fieldAry.find(function (f) { return ['relation', 'SYS_USER', 'SYS_ROLE', 'SYS_ROLE_RELATION'].includes(f.bizType) && f.relationEntityId === originEntity.id && (parentField.bizType === 'mapping' ? true : f.id === parentField.id); });
                    var mappingTableName = __spreadArray(__spreadArray([], fromPath.map(function (p) { return p.name; }), true), [parentField.name], false).join('_');
                    /** 聚合为 json 的字段列表 */
                    var jsonFieldNameList_1 = [];
                    /** 标识对应的 json 字段是否已被拼接 */
                    var jsonMappingFieldMap_1 = {};
                    fields
                        .filter(function (f) { return f.fromPath.find(function (path, idx) { return path.fieldId === parentField.id && path.entityId === parentEntity.id && idx + 1 === depIndex; }); })
                        .forEach(function (f) {
                        var currentField = entityFieldMap_1[f.entityId + f.fieldId];
                        var index = f.fromPath.findIndex(function (path, idx) { return path.fieldId === parentField.id && path.entityId === parentEntity.id && idx + 1 === depIndex; });
                        /** 字段来源于当前表中 */
                        if (f.fromPath.length - 1 === index) {
                            if (![FieldBizType.MAPPING].includes(currentField.bizType)) {
                                /** 判断是否是映射字段，是则加 _ 标识 */
                                var isMapping = fields.find(function (p) { return p.fromPath.length === f.fromPath.length + 1 && p.fromPath[p.fromPath.length - 1].fieldId === currentField.id; });
                                jsonFieldNameList_1.push("'".concat(isMapping ? '_' : '').concat(currentField.name, "', ").concat(currentField.bizType === FieldBizType.CALC ? currentField.sql : currentField.name));
                            }
                        }
                        else {
                            var entityFieldMapElement = entityFieldMap_1[f.fromPath[index + 1].entityId + f.fromPath[index + 1].fieldId];
                            /** 聚合为 JSON 时，字段取父字段的名称，如 MAPPING_A_B_C，取名称 B */
                            if (!jsonMappingFieldMap_1[entityFieldMapElement.name]) {
                                jsonFieldNameList_1.push("'".concat(entityFieldMapElement.name, "', ").concat(entityFieldMapElement.name, "_JSON"));
                                jsonMappingFieldMap_1[entityFieldMapElement.name] = 1;
                            }
                        }
                    });
                    /** 需要在子查询中返回的字段列表 */
                    var extraFieldNames = allFields_1
                        .filter(function (f) { return (f.fromCalcField ? f.fromCalcField.fromPath.length < depIndex : true) && f.fromPath.find(function (path, idx) { return path.fieldId === parentField.id && path.entityId === parentEntity.id && idx + 1 === depIndex; }) && (f.entityId === originEntity.id ? !entityFieldMap_1[f.entityId + f.fieldId].isPrimaryKey : true); })
                        .map(function (f) {
                        var currentField = entityFieldMap_1[f.entityId + f.fieldId];
                        var index = f.fromPath.findIndex(function (path, idx) { return path.fieldId === parentField.id && path.entityId === parentEntity.id && idx + 1 === depIndex; });
                        var mappingFieldName = "MAPPING_".concat(__spreadArray(__spreadArray([], (f.fromPath.map(function (path) { return entityFieldMap_1[path.entityId + path.fieldId].name; })), true), [
                            /** 查询总数逻辑定制 */
                            currentField.isPrimaryKey && f.fieldName === '总数' ? f.fieldName : currentField.name
                        ], false).join('_'));
                        /** 字段来源于当前表中 */
                        if (f.fromPath.length - 1 === index) {
                            if (![FieldBizType.MAPPING].includes(currentField.bizType)) {
                                return "".concat(currentField.bizType === FieldBizType.CALC ? currentField.sql : currentField.name, " AS ").concat(mappingFieldName);
                            }
                        }
                        else {
                            /** 字段来源于子查询 */
                            return mappingFieldName;
                        }
                    })
                        .filter(Boolean);
                    entityName = "LEFT JOIN (SELECT id AS MAPPING_".concat(mappingTableName, "_id").concat(extraFieldNames.length ? ", ".concat(extraFieldNames.join(', ')) : '').concat(jsonFieldNameList_1.length ? ", JSON_OBJECT(".concat(jsonFieldNameList_1.join(', '), ") ").concat(parentField.name, "_JSON") : '', " FROM ").concat(getTableName_1(originEntity.name), " ").concat(leftJoinSqlList.join(' '), " WHERE _STATUS_DELETED = 0) MAPPING_").concat(mappingTableName, " ON MAPPING_").concat(mappingTableName, ".MAPPING_").concat(mappingTableName, "_id = ").concat(getTableName_1(parentEntity.name), ".").concat((relationField_1 === null || relationField_1 === void 0 ? void 0 : relationField_1.name));
                }
                else if (type === 'foreigner') {
                    /** 被关联，当前实体被另一实体关联，即当前实体的主键（id）被另一个实体作为外键相互关联 */
                    var mappingTableName = __spreadArray(__spreadArray([], fromPath.map(function (p) { return p.name; }), true), [parentField.name], false).join('_');
                    /** 被关联的关系字段 */
                    var curRelationFieldName = 'MAPPING_' + [mappingTableName, relationField === null || relationField === void 0 ? void 0 : relationField.name].join('_');
                    /** 聚合为 json 的字段列表 */
                    var jsonFieldNameList_2 = [];
                    /** 标识对应的 json 字段是否已被拼接 */
                    var jsonMappingFieldMap_2 = {};
                    fields
                        .filter(function (f) { return f.fromPath.find(function (path, idx) { return path.fieldId === parentField.id && path.entityId === parentEntity.id && idx + 1 === depIndex; }); })
                        .forEach(function (f) {
                        var currentField = entityFieldMap_1[f.entityId + f.fieldId];
                        var index = f.fromPath.findIndex(function (path, idx) { return path.fieldId === parentField.id && path.entityId === parentEntity.id && idx + 1 === depIndex; });
                        if (f.fromPath.length - 1 === index) {
                            /** 判断是否是映射字段，是则加 _ 标识 */
                            var isMapping = fields.find(function (p) { return p.fromPath.length === f.fromPath.length + 1 && p.fromPath[p.fromPath.length - 1].fieldId === currentField.id; });
                            jsonFieldNameList_2.push("'".concat(isMapping ? '_' : '').concat(currentField.name, "', ").concat(currentField.bizType === FieldBizType.CALC ? currentField.sql : currentField.name));
                        }
                        else {
                            /** 聚合为 JSON 时，字段取父字段的名称，如 MAPPING_A_B_C，取名称 B */
                            var entityFieldMapElement = entityFieldMap_1[f.fromPath[index + 1].entityId + f.fromPath[index + 1].fieldId];
                            if (!jsonMappingFieldMap_2[entityFieldMapElement.name]) {
                                jsonFieldNameList_2.push("'".concat(entityFieldMapElement.name, "', ").concat(entityFieldMapElement.name, "_JSON"));
                                jsonMappingFieldMap_2[entityFieldMapElement.name] = 1;
                            }
                        }
                    });
                    /** 需要在子查询中返回的字段列表 */
                    if (condition === '-1') {
                        var extraFieldNames = allFields_1
                            .filter(function (f) {
                            var entityField = entityFieldMap_1[f.entityId + f.fieldId];
                            return (f.fromCalcField ? f.fromCalcField.fromPath.length < depIndex : true) && f.fromPath.find(function (path, idx) { return path.fieldId === parentField.id && path.entityId === parentEntity.id && idx + 1 === depIndex; }) && (f.entityId === originEntity.id ? !entityField.isPrimaryKey : true) && entityField.name !== (relationField === null || relationField === void 0 ? void 0 : relationField.name);
                        })
                            .map(function (f) {
                            var index = f.fromPath.findIndex(function (path, idx) { return path.fieldId === parentField.id && path.entityId === parentEntity.id && idx + 1 === depIndex; });
                            var currentField = entityFieldMap_1[f.entityId + f.fieldId];
                            var mappingFieldName = "MAPPING_".concat(__spreadArray(__spreadArray([], (f.fromPath.map(function (path) { return entityFieldMap_1[path.entityId + path.fieldId].name; })), true), [currentField.name], false).join('_'));
                            if (f.fromPath.length - 1 === index) {
                                return "GROUP_CONCAT(".concat(currentField.bizType === FieldBizType.CALC ? currentField.sql : currentField.name, " SEPARATOR \"").concat(SEPARATOR, "\") ").concat(mappingFieldName);
                            }
                            else if (currentField.bizType !== FieldBizType.MAPPING) {
                                /** GROUP_CONCAT 必须保留，因为外层 where 条件中会使用 */
                                return "GROUP_CONCAT(".concat(mappingFieldName, " SEPARATOR \"").concat(SEPARATOR, "\") ").concat(mappingFieldName);
                            }
                        })
                            .filter(Boolean);
                        entityName = "LEFT JOIN (SELECT GROUP_CONCAT(id SEPARATOR \"".concat(SEPARATOR, "\") MAPPING_").concat(mappingTableName, "_id, GROUP_CONCAT(").concat(relationField === null || relationField === void 0 ? void 0 : relationField.name, " SEPARATOR \"").concat(SEPARATOR, "\") ").concat(curRelationFieldName).concat(extraFieldNames.length ? ", ".concat(extraFieldNames.join(', ')) : '').concat(jsonFieldNameList_2.length ? ", JSON_ARRAYAGG(JSON_OBJECT(".concat(jsonFieldNameList_2.join(', '), ")) ").concat(parentField.name, "_JSON") : '', " FROM ").concat(getTableName_1(originEntity.name), " ").concat(leftJoinSqlList.join(' '), " WHERE _STATUS_DELETED = 0 GROUP BY ").concat(relationField === null || relationField === void 0 ? void 0 : relationField.name, ") MAPPING_").concat(mappingTableName, " ON MAPPING_").concat(mappingTableName, ".").concat(curRelationFieldName, " = ").concat(getTableName_1(parentEntity.name), ".id");
                    }
                    else if (isMaxCondition) {
                        /** 从条件中提取字段 */
                        var filedName = condition.substr(4, condition.length - 5);
                        /** 需要在子查询中返回的字段列表 */
                        var extraFieldNames = allFields_1
                            .filter(function (f) {
                            var entityField = entityFieldMap_1[f.entityId + f.fieldId];
                            return (f.fromCalcField ? f.fromCalcField.fromPath.length < depIndex : true) && f.fromPath.find(function (path, idx) { return path.fieldId === parentField.id && path.entityId === parentEntity.id && idx + 1 === depIndex; }) && (f.entityId === originEntity.id ? !entityField.isPrimaryKey : true) && entityField.name !== (relationField === null || relationField === void 0 ? void 0 : relationField.name);
                        })
                            .map(function (f) {
                            var index = f.fromPath.findIndex(function (path, idx) { return path.fieldId === parentField.id && path.entityId === parentEntity.id && idx + 1 === depIndex; });
                            var currentField = entityFieldMap_1[f.entityId + f.fieldId];
                            var mappingFieldName = "MAPPING_".concat(__spreadArray(__spreadArray([], (f.fromPath.map(function (path) { return entityFieldMap_1[path.entityId + path.fieldId].name; })), true), [currentField.name], false).join('_'));
                            if (f.fromPath.length - 1 === index) {
                                return "".concat(currentField.bizType === FieldBizType.CALC ? currentField.sql : currentField.name, " AS ").concat(mappingFieldName);
                            }
                            else if (currentField.bizType !== FieldBizType.MAPPING) {
                                return mappingFieldName;
                            }
                        })
                            .filter(Boolean);
                        entityName = "LEFT JOIN (SELECT GROUP_CONCAT(id SEPARATOR \"".concat(SEPARATOR, "\") MAPPING_").concat(mappingTableName, "_id, GROUP_CONCAT(").concat(relationField === null || relationField === void 0 ? void 0 : relationField.name, " SEPARATOR \"").concat(SEPARATOR, "\") ").concat(curRelationFieldName).concat(extraFieldNames.length ? ", ".concat(extraFieldNames.join(', ')) : '').concat(jsonFieldNameList_2.length ? ", JSON_ARRAYAGG(JSON_OBJECT(".concat(jsonFieldNameList_2.join(', '), ")) ").concat(parentField.name, "_JSON") : '', " FROM ").concat(getTableName_1(originEntity.name), " ").concat(leftJoinSqlList.join(' '), " WHERE _STATUS_DELETED = 0 AND ").concat(filedName, " IN (SELECT max(").concat(filedName, ") FROM ").concat(getTableName_1(originEntity.name), " WHERE _STATUS_DELETED = 0 GROUP BY ").concat(relationField.name, ")) MAPPING_").concat(mappingTableName, " ON MAPPING_").concat(mappingTableName, ".").concat(curRelationFieldName, " = ").concat(getTableName_1(parentEntity.name), ".id");
                    }
                    else if (condition.startsWith('count(') && condition.endsWith(')')) {
                        entityName = "LEFT JOIN (SELECT ".concat(relationField === null || relationField === void 0 ? void 0 : relationField.name, " AS ").concat(curRelationFieldName, ", COUNT(id) AS MAPPING_").concat(mappingTableName, "_\u603B\u6570, JSON_OBJECT('\u603B\u6570', COUNT(id)) ").concat(parentField.name, "_JSON FROM ").concat(getTableName_1(originEntity.name), " ").concat(leftJoinSqlList.join(' '), " WHERE _STATUS_DELETED = 0 GROUP BY ").concat(relationField === null || relationField === void 0 ? void 0 : relationField.name, ") MAPPING_").concat(mappingTableName, " ON MAPPING_").concat(mappingTableName, ".").concat(curRelationFieldName, " = ").concat(getTableName_1(parentEntity.name), ".id");
                    }
                }
                entityName && entityNames.push(entityName);
            });
            return entityNames;
        };
        /** mapping 字段，存在数据映射且实体存在 */
        entityNames.push.apply(entityNames, spliceLeftJoinSql_1(curEntity.fieldAry
            .filter(function (field) {
            var _a, _b, _c;
            return curFieldIds_1.includes(field.id) && ((_c = (_b = (_a = field.mapping) === null || _a === void 0 ? void 0 : _a.entity) === null || _b === void 0 ? void 0 : _b.fieldAry) === null || _c === void 0 ? void 0 : _c.length) && entityMap_1[field.mapping.entity.id];
        }), 1, [], curEntity));
        /** 字段去重 */
        var newFieldIds_1 = [];
        var newFields = fields.map(function (field) {
            var curField = field;
            if (!field.fromPath.length) {
                var entityField = entityFieldMap_1[field.entityId + field.fieldId];
                /** 如果映射类型，没有选择内部的字段，则忽略映射类型字段 */
                if (entityField.bizType === 'mapping' && !fields.find(function (f) { var _a; return ((_a = f.fromPath[0]) === null || _a === void 0 ? void 0 : _a.fieldId) === field.fieldId; })) {
                    return undefined;
                }
            }
            else {
                curField = field.fromPath[0];
            }
            if (newFieldIds_1.includes(curField.fieldId)) {
                return undefined;
            }
            else {
                newFieldIds_1.push(curField.fieldId);
                return curField;
            }
        }).filter(Boolean);
        /** 字段列表 */
        newFields
            .map(function (field) {
            var entityField = entityFieldMap_1[field.entityId + field.fieldId];
            if (entityField.bizType === 'mapping') {
                fieldList_1.push("".concat(entityField.name, "_JSON AS ").concat(entityField.name));
                return;
            }
            if (entityField.bizType === 'relation' && fields.find(function (p) { var _a; return ((_a = p.fromPath[0]) === null || _a === void 0 ? void 0 : _a.fieldId) === field.fieldId; })) {
                fieldList_1.push("".concat(entityField.name, " AS _").concat(entityField.name), "".concat(entityField.name, "_JSON AS ").concat(entityField.name));
            }
            else {
                fieldList_1.push(entityField.name);
            }
        });
        var whereSql = spliceWhereSQLFragmentByConditions({
            conditions: [conditions],
            entities: entities,
            params: params,
            entityMap: entityMap_1,
            curEntity: curEntity,
            entityFieldMap: entityFieldMap_1
        });
        console.log("whereSql: ", whereSql);
        /** 前置 sql */
        sql.push("SELECT ".concat(fieldList_1.join(', '), " FROM ").concat(entityNames.join(' ')));
        sql.push(whereSql);
        if (showPager || selectCount) {
            countSql.push("SELECT count(*) as total FROM ".concat(entityNames.join(' ')));
            countSql.push(whereSql);
        }
        /** 单独查询总数 */
        if (selectCount) {
            return ['', countSql.join(' ')];
        }
        if (orders.length) {
            var orderList_1 = [];
            orders.forEach(function (order) {
                var _a, _b, _c, _d;
                var entityField = entityFieldMap_1[order.entityId + order.fieldId];
                if (!entityField) {
                    return;
                }
                if (order.fromPath.length) {
                    var lastPath = order.fromPath[order.fromPath.length - 1];
                    var parentField = entityFieldMap_1[lastPath.entityId + lastPath.fieldId];
                    var isCountCondition = ((_b = (_a = parentField.mapping) === null || _a === void 0 ? void 0 : _a.condition) === null || _b === void 0 ? void 0 : _b.startsWith('count(')) && ((_d = (_c = parentField.mapping) === null || _c === void 0 ? void 0 : _c.condition) === null || _d === void 0 ? void 0 : _d.endsWith(')'));
                    orderList_1.push("MAPPING_".concat(__spreadArray(__spreadArray([], order.fromPath.map(function (path) { return entityFieldMap_1[path.entityId + path.fieldId].name; }), true), [isCountCondition ? '总数' : entityField.name], false).join('_'), " ").concat(order.order));
                }
                else {
                    orderList_1.push("".concat(entityField.name, " ").concat(order.order));
                }
            });
            orderList_1.length && sql.push("ORDER BY ".concat(orderList_1.join(', ')));
        }
        var limitValue = limit.value ? String(limit.value) : '';
        if (limitValue) {
            if (limitValue.startsWith('{') && limitValue.endsWith('}')) {
                limitValue = params[limitValue.slice(limitValue.indexOf('.') + 1, -1)] || 50;
                if (limitValue) {
                    sql.push("LIMIT ".concat(limitValue));
                }
            }
            else {
                sql.push("LIMIT ".concat(limitValue));
            }
        }
        if (pageNum) {
            if (pageNum.startsWith('{') && pageNum.endsWith('}')) {
                var curValue = params[pageNum.slice(pageNum.indexOf('.') + 1, -1)];
                if (curValue) {
                    sql.push("OFFSET ".concat((Number(curValue) - 1) * Number(limitValue)));
                }
            }
            else if (!Number.isNaN(Number(pageNum))) {
                sql.push("OFFSET ".concat((Number(pageNum) - 1) * Number(limitValue)));
            }
        }
        return [sql.join(' '), countSql.join(' ')];
    }
};
